import React from 'react';
import moment, { Moment } from 'moment';
import { MetricKind } from '@/webapi/models';

export async function sleep(
  timeoutRef: React.MutableRefObject<NodeJS.Timeout | undefined>,
  ms: number,
) {
  await new Promise((resolve) => {
    timeoutRef.current = setTimeout(resolve, ms);
  });
  timeoutRef.current = undefined;
}

export function validateEmail(val) {
  return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,10}$/i.test(val);
}

export function dateToUtcInSeconds(date?: Date): number {
  if (!date) {
    const date = new Date();
    return Math.round(date.getTime() / 1000);
  }
  return Math.round(date.getTime() / 1000);
}

export function utcInSecToDate(utc) {
  return new Date(Math.round(Number(utc) * 1000));
}

export function dateToUtcInSec(value: Moment | string | number) {
  return Math.round(moment(value).toDate().getTime() / 1000);
}

export function get24HourTimeString(hours = 0, minutes = 0): string {
  return new Date(0, 0, 0, hours, minutes).toLocaleTimeString([], {
    hour: `2-digit`,
    minute: `2-digit`,
    hour12: false,
  });
}

export function formatToLocalDate(date: string | Date, isPublished?: boolean) {
  let dateForCalculation: string | Date = date;

  if (typeof dateForCalculation === `string`) {
    const lastChar = dateForCalculation[dateForCalculation.length - 1];
    if (
      lastChar !== `Z` &&
      !dateForCalculation.includes(`+`) &&
      !dateForCalculation.includes(`-`)
    ) {
      dateForCalculation += `Z`;
    }
  }

  const dateObj = new Date(dateForCalculation);

  const now = new Date();
  const diffMs = now.getTime() - dateObj.getTime();
  const diffMinutes = diffMs / (1000 * 60);
  if (diffMinutes < 1) {
    return `Just now`;
  }
  if (diffMinutes < 60) {
    const minutes = Math.floor(diffMinutes);
    return `${minutes} ${minutes === 1 ? `minute` : `minutes`} ago`;
  }
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const dateDay = new Date(
    dateObj.getFullYear(),
    dateObj.getMonth(),
    dateObj.getDate(),
  );
  const dayDiff = Math.floor(
    (today.getTime() - dateDay.getTime()) / (1000 * 60 * 60 * 24),
  );
  if (dayDiff === 0) {
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    return `${diffHours} ${diffHours === 1 ? `hour` : `hours`} ago`;
  }
  if (dayDiff === 1) {
    return `Yesterday`;
  }
  if (dayDiff === 2) {
    return `2 days ago`;
  }
  const day = dateObj.getDate();
  const month = dateObj.toLocaleDateString(`en-US`, { month: `short` });
  const year = dateObj.getFullYear();
  if (isPublished) {
    const weekday = dateObj.toLocaleDateString(`en-US`, { weekday: `short` });
    return `${weekday}, ${day} ${month} ${year}`;
  }
  return `${day} ${month} ${year}`;
}
export function maybe<T>(f: () => T, def: T | undefined = undefined) {
  try {
    return f();
  } catch {
    return def;
  }
}

export function notProfitMetric() {
  return (m) =>
    !(m === MetricKind.PROFIT || m === MetricKind.PROFIT_PER_SESSION);
}

export function notReturnsMetric() {
  return (m) =>
    !(m === MetricKind.RETURNS || m === MetricKind.RETURNS_PER_SESSION);
}
